var _g, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCustomTender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 32,
    height: 22,
    rx: 4,
    fill: "#FFE57F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.82324,
    y: 1,
    width: 26.3529,
    height: 1.83333,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.82324,
    y: 21.1665,
    width: 26.3529,
    height: 1.83333,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 20.25,
    width: 16.5,
    height: 1.88235,
    transform: "rotate(-90 0 20.25)",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1172,
    y: 20.25,
    width: 16.5,
    height: 1.88235,
    transform: "rotate(-90 30.1172 20.25)",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9996,
    cy: 12,
    rx: 5.64706,
    ry: 5.5,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29412,
    cy: 4.20833,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.58816,
    cy: 11.9998,
    rx: 1.88235,
    ry: 1.83333,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.4116,
    cy: 11.9998,
    rx: 1.88235,
    ry: 1.83333,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29412,
    cy: 19.7918,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7062,
    cy: 4.20833,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7062,
    cy: 19.7918,
    rx: 3.29412,
    ry: 3.20833,
    fill: "#F7931A"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 16.12C14.8009 16.12 15.8209 15.56 16.4409 14.69L15.3809 13.92C14.9909 14.47 14.4109 14.81 13.6709 14.81C12.4209 14.81 11.5209 13.78 11.5209 12.55C11.5209 11.32 12.4309 10.3 13.6809 10.3C14.4109 10.3 14.9909 10.64 15.3809 11.19L16.4409 10.42C15.8209 9.55 14.8009 8.99 13.6309 8.99C11.6809 8.99 10.1309 10.61 10.1309 12.55C10.1309 14.51 11.6809 16.12 13.6309 16.12ZM22.0931 9.11H16.9031V10.34H18.8031V16H20.1931V10.34H22.0931V9.11Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomTender);
export default __webpack_public_path__ + "static/media/IconCustomTender.cc1ef762.svg";
export { ForwardRef as ReactComponent };